import Vue from "vue";
import Vuex from "vuex";

import home from "./home.module";
import auth from "./auth.module";
import article from "./article.module";
import profile from "./profile.module";
import register from "./register.module";
import cart from "./cart.module";
import favorite from "./favorite.module";
import category from "./category.module";
import type from "./type.module";
import user from "./user.module";
import forgot from "./forgot.module";
import order from "./order.module";
import withdrawal from "./withdrawal.module";
import product from "./product.module";
import good from "./good.module";
import shipping from "./shipping.module";
import news from "./news.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    home,
    auth,
    article,
    profile,
    register,
    cart,
    favorite,
    category,
    type,
    user,
    forgot,
    order,
    withdrawal,
    product,
    good,
    shipping,
    news
  }
});
